export default {
  currentUser: {
    uid: '',
    name: 'no login',
    email: '',
    avatarUrl: '/assets/images/default-avatar.png'
  },
  project: {
    items: []
  },
  userTask: {
    hiddenUids: [],
    users: []
    //users: [
    //  {
    //    uid: 'xxx',
    //    name: 'yyy',
    //    avatarUrl: 'xxxx.png',
    //    tasks: [
    //      {
    //        name: 'aaa',
    //        startAt: '"yyyy-mm-ddThh:MM:SS.000Z"',
    //        endAt: '"yyyy-mm-ddThh:MM:SS.000Z"',
    //        project: 'abcdef',
    //        projectLabel: '000-PPPP',
    //        projectColor: 'hsl(100, 60%, 90%)',
    //        hours: n
    //      }
    //    ],
    //    dailyHours: {
    //      dMMDD: 8,
    //      dMMDD: 0,
    //      dMMDD: 4,
    //    }
    //  }
    //]
  }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/